import { useAuth } from '~/lib/auth';

export type IAnonymousGuardProps = {
  children: React.ReactElement;
};

export const LoggedInUserChildGuard: React.FC<IAnonymousGuardProps> = ({
  children,
}) => {
  const { isAuthenticated } = useAuth();

  return isAuthenticated ? children : false;
};
